// AgentVerse/common/schemas/collections/taskInstances.js
import { z } from "zod";

const TaskInstanceSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    
    // Core Scoping & Identification
    name: z.string().min(1, "Instance name is required."),
    description: z.string().optional().nullable(),
    contextId: z.string().describe("The primary ID for scoping (e.g., projectId, userId, agentInstanceId)."),
    contextType: z.enum(['project', 'subscription', 'thread', 'user', 'agent', 'workflow', 'tool']).describe("The type of context."),
    
    // Ownership & Access Control
    ownerId: z.string().describe("The user or agent (contactId) who owns/created this instance."),
    accessControl: z.object({
        // Arrays of MessagingContact IDs or Role names
        viewers: z.array(z.string()).optional().default([]), 
        editors: z.array(z.string()).optional().default([]),
        commenters: z.array(z.string()).optional().default([]),
    }).optional().describe("Defines who can view, edit, or comment on tasks within this instance."),
    
    // Flexible Metadata
    metadata: z.record(z.any()).optional().describe("Flexible key-value metadata for additional context (e.g., { browserSessionId: 'xyz' })."),
    
    // State & Timestamps
    isArchived: z.boolean().default(false).describe("Whether this entire task instance is archived."),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default TaskInstanceSchema;